export default "__VITE_ASSET__DYQcCYqP__"